<template>
  <section class="realtime-data-panel">
    <div class="panel-header">
      <div class="update-time"></div>
      <div class="header-center">
        <div class="main-title">农田、温室、养殖场实时数据与状态</div>
        <div class="sub-title">多场景联动监测 | 环境指标 | 设备状态 | 异常提醒</div>
      </div>
      <div class="online">在线设备 <span>{{ onlineCount }}</span>台</div>
    </div>
    <div class="scene-list">
      <SceneStatusCard
        v-for="item in scenes"
        :key="item.title"
        :title="item.title"
        :icon="item.icon"
        :video-title="item.videoTitle"
        :src="item.src"
        :type="item.type"
        :poster="item.poster"
        :cameras="item.cameras"
        :metrics="item.metrics"
        @open-video="openVideo(item)"
      />
    </div>
  </section>
  <popBg
    v-if="popShow && currentScene"
    :title="currentScene.videoTitle"
    :code="currentScene.code"
    :popShow="popShow"
    @hiddlen="closeVideo"
  >
    <div class="ys-iframe-wrap">
      <iframe
        :src="currentIframeSrc"
        width="100%"
        height="100%"
        allowfullscreen
      ></iframe>
    </div>
  </popBg>
</template>

<script setup>
import { computed, onBeforeUnmount, onMounted, ref } from "vue";
import popBg from "@/components/popBg.vue";
import SceneStatusCard from "./SceneStatusCard.vue";

defineProps({
  scenes: {
    type: Array,
    required: true,
  },
  onlineCount: {
    type: Number,
    default: 48,
  },
});

const now = ref(new Date());
const popShow = ref(false);
const currentScene = ref(null);
const accessToken = ref("");
let timer = null;
const pad = (value) => String(value).padStart(2, "0");
const clockText = computed(() => {
  const date = now.value;
  return `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
});
const currentIframeSrc = computed(() => {
  if (!currentScene.value) return "";
  return `${currentScene.value.iframeSrc || ""}${accessToken.value || ""}`;
});

function openVideo(scene) {
  currentScene.value = scene;
  accessToken.value = localStorage.getItem("AccessToken") || "";
  popShow.value = true;
}

function closeVideo() {
  popShow.value = false;
  currentScene.value = null;
}

onMounted(() => {
  accessToken.value = localStorage.getItem("AccessToken") || "";
  timer = setInterval(() => {
    now.value = new Date();
  }, 1000);
});

onBeforeUnmount(() => {
  clearInterval(timer);
});
</script>

<style lang="less" scoped>
.realtime-data-panel {
  width: 100%;
  height: auto;
  padding: 0 50px 50px;
  box-sizing: border-box;
  background:
    radial-gradient(circle at 50% 0, rgba(36, 255, 228, 0.16), transparent 40%),
    linear-gradient(180deg, rgba(0, 48, 45, 0.76), rgba(0, 19, 21, 0.95));
  border: 1px solid rgba(63, 218, 206, 0.38);
  box-shadow: inset 0 0 44px rgba(33, 255, 232, 0.14);
  display: flex;
  flex-direction: column;
}

.panel-header {
  position: relative;
  height: 200px;
  display: grid;
  grid-template-columns: 250px minmax(0, 1fr) 190px;
  align-items: start;
}

.panel-header::before,
.panel-header::after {
  content: "";
  position: absolute;
  top: 28px;
  width: 190px;
  height: 24px;
  background: repeating-linear-gradient(60deg, rgba(94, 246, 230, 0.82) 0 10px, transparent 10px 17px);
  opacity: 0.85;
}

.panel-header::before {
  left: 222px;
}

.panel-header::after {
  right: 196px;
}

.update-time,
.online {
  padding-top: 30px;
  color: #f1fffb;
  font-size: 26px;
  font-weight: 800;
  text-shadow: 0 0 6px rgba(92, 255, 237, 0.58);
}

.update-time {
  text-align: left;
}

.online {
  text-align: right;
}

.online span {
  margin: 0 4px;
}

.header-center {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.main-title {
  min-width: 560px;
  height: 104px;
  padding: 0 62px;
  box-sizing: border-box;
  line-height: 104px;
  color: #fff;
  font-size: 60px;
  font-weight: 900;
  text-align: center;
  background:
    linear-gradient(180deg, rgba(10, 117, 111, 0.94), rgba(6, 68, 72, 0.96));
  border: 2px solid rgba(73, 235, 222, 0.72);
  border-top: none;
  clip-path: polygon(0 0, 100% 0, calc(100% - 34px) 100%, 34px 100%);
  text-shadow: 0 0 10px rgba(119, 255, 239, 0.72);
}

.sub-title {
  margin-top: 20px;
  color: #f6fffc;
  font-size: 32px;
  font-weight: 800;
  text-align: center;
  text-shadow: 0 0 8px rgba(90, 255, 235, 0.66);
}

.scene-list {
  // height: 362px;
  flex: 1;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 50px;
  padding: 0 30px ;
}

.ys-iframe-wrap {
  width: 100%;
  height: 100%;
}

.ys-iframe-wrap iframe {
  display: block;
  width: 100%;
  height: 100%;
  border: 0;
}
</style>
